import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Divider,
  Container,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import RestoreIcon from '@mui/icons-material/Restore';
import { jwtDecode } from 'jwt-decode';
import { useLocation, useParams } from 'react-router-dom';
import axiosInstance from '../services/axiosInterceptors';
import apiEndPointsConfig from '../services/apiEndPoints';

const RediarizationPrompt = () => {

  const { companyId, processType } = useParams();
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";
  const [promptData, setPromptData] = useState({})
  const [messages, setMessages] = useState(promptData);
  const [loading, setLoading] = useState(true);
  const location = useLocation();



  console.log(companyId, "companyId", processType, "processType");

  const payload = {
    companyId,
    processType,
    promptType: "REDIARIZATION"
  }

  const fetchClientPromptData = async (data) => {
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.clinetPromptData,
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessages(res?.data?.data[0]?.rediarizationPrompt?.systemPrompts
      );
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode === 401) {
        localStorage.clear();
      } else {
        console.error("Error while fetching dashboard details :", error);
      }
    }
  };

  const updateClientPromptData = async (data) => {
    try {
      const updatePayload = {
        companyId,
        processType,
        rediarizationPrompt: messages
      };
      const res = await axiosInstance.patch(
        apiEndPointsConfig?.updateClientPrompt,
        updatePayload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchClientPromptData(payload)
    } catch (error) {
      console.error("Update failed", error);
    }
  };
  const ProcessPayload = {
    companyId,
    process: processType
  }

  const fetchProcessPromptData = async (data) => {
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.processPromptData,
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessages(res?.data?.data[0]?.rediarizationPrompt?.systemPrompts
      );
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode === 401) {
        localStorage.clear();
      } else {
        console.error("Error while fetching dashboard details :", error);
      }
    }
  };

  useEffect(() => {
    if (location.state?.from === "/super-admin/process-management") {
      fetchProcessPromptData(ProcessPayload)
    } else {
      fetchClientPromptData(payload);
    }

  }, []);

  // useEffect(() => {
  //   fetchClientPromptData(payload);
  // }, []);

  const [editingMessage, setEditingMessage] = useState(null);
  const [tempValue, setTempValue] = useState('');
  const [expanded, setExpanded] = useState('m1');


  const messageTitles = {
    m1: "System Role Definition",
    m2: "Transcript Understanding",
    m3: "Entity Categories",
    m4: "Extraction Logic",
    m5: "Output Format",
    m6: "JSON Format Specification",
    m7: "Output Constraints"
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleEdit = (messageKey) => {
    setEditingMessage(messageKey);
    setTempValue(messages[messageKey]);
  };

  const handleSave = (messageKey) => {
    setMessages({ ...messages, [messageKey]: tempValue });
    setEditingMessage(null);
    setTempValue('');
  };

  const handleCancel = () => {
    setEditingMessage(null);
    setTempValue('');
  };

  const handleReset = (messageKey) => {
    setMessages({ ...messages, [messageKey]: messages[messageKey] });
    setEditingMessage(null);
    setTempValue('');
  };

  const handleResetAll = () => {
    setMessages(messages);
    setEditingMessage(null);
    setTempValue('');
  };

  const handleSaveAll = () => {
    updateClientPromptData()
  };

  const getMessageNumber = (key) => key.replace('m', '');

  return (
    <Box sx={{ backgroundColor: '#f5f7fa', minHeight: '100vh', p: 4 }}>
      <Box >
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            backgroundColor: 'white',
            borderRadius: 3,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="h5" fontWeight="bold" sx={{ mb: 0.5, color: "#7626dc" }}>
                Prompt Configuration
              </Typography>
              <Typography variant="body2">
                Configure and customize AI prompt messages for rediarization
              </Typography>
            </Box>
            <Stack direction="row" spacing={2}>
              <Button
                startIcon={<RestoreIcon />}
                onClick={handleResetAll}
                variant="outlined"
                sx={{ textTransform: 'none' }}
              >
                Reset All
              </Button>
              <Button
                variant="contained"
                onClick={handleSaveAll}
                sx={{
                  textTransform: 'none',
                  backgroundColor: '#7626dc',
                  '&:hover': { backgroundColor: '#0288d1' },
                  px: 3,
                }}
              >
                Save All Changes
              </Button>
            </Stack>
          </Box>
        </Paper>

        {/* Messages Section */}
        <Stack spacing={2}>
          {Object.entries(messages).map(([key, value]) => (
            <Accordion
              key={key}
              expanded={expanded === key}
              onChange={handleAccordionChange(key)}
              sx={{
                backgroundColor: 'white',
                '&:before': { display: 'none' },
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                borderRadius: '8px !important',
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  '&:hover': { backgroundColor: '#f8f9fa' },
                  borderRadius: 2,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%', pr: 2 }}>
                  <Chip
                    label={`M${getMessageNumber(key)}`}
                    size="small"
                    sx={{
                      backgroundColor: '#7626dc',
                      color: 'white',
                      fontWeight: 'bold',
                      minWidth: 45,
                    }}
                  />
                  <Typography fontWeight={600} sx={{ flexGrow: 1 }}>
                    {messageTitles[key]}
                  </Typography>
                  {messages[key] !== messages[key] && (
                    <Chip
                      label="Modified"
                      size="small"
                      color="warning"
                      sx={{ fontSize: '0.7rem' }}
                    />
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Divider sx={{ mb: 2 }} />
                {editingMessage === key ? (
                  <Box>
                    <TextField
                      fullWidth
                      multiline
                      minRows={4}
                      maxRows={12}
                      value={tempValue}
                      onChange={(e) => setTempValue(e.target.value)}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiOutlinedInput-root': {
                          fontFamily: 'monospace',
                          fontSize: '0.9rem',
                        },
                      }}
                    />
                    <Stack direction="row" spacing={1}>
                      <Button
                        startIcon={<SaveIcon />}
                        variant="contained"
                        size="small"
                        onClick={() => handleSave(key)}
                        sx={{ textTransform: 'none' }}
                      >
                        Save
                      </Button>
                      <Button
                        startIcon={<CancelIcon />}
                        variant="outlined"
                        size="small"
                        onClick={handleCancel}
                        sx={{ textTransform: 'none' }}
                      >
                        Cancel
                      </Button>
                      {messages[key] !== messages[key] && (
                        <Button
                          startIcon={<RestoreIcon />}
                          variant="outlined"
                          color="warning"
                          size="small"
                          onClick={() => handleReset(key)}
                          sx={{ textTransform: 'none' }}
                        >
                          Reset to Default
                        </Button>
                      )}
                    </Stack>
                  </Box>
                ) : (
                  <Box>
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 2,
                        mb: 2,
                        backgroundColor: '#f8f9fa',
                        fontFamily: 'monospace',
                        fontSize: '0.9rem',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                        maxHeight: 300,
                        overflow: 'auto',
                      }}
                    >
                      {value}
                    </Paper>
                    <Stack direction="row" spacing={1}>
                      <Button
                        startIcon={<EditIcon />}
                        variant="contained"
                        size="small"
                        onClick={() => handleEdit(key)}
                        sx={{ textTransform: 'none' }}
                      >
                        Edit Message
                      </Button>
                      {messages[key] !== messages[key] && (
                        <Button
                          startIcon={<RestoreIcon />}
                          variant="outlined"
                          color="warning"
                          size="small"
                          onClick={() => handleReset(key)}
                          sx={{ textTransform: 'none' }}
                        >
                          Reset to Default
                        </Button>
                      )}
                    </Stack>
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </Stack>

        {/* Info Section */}
        <Paper
          elevation={0}
          sx={{
            p: 2,
            mt: 3,
            backgroundColor: 'white',
            borderRadius: 2,
            border: '1px solid #e0e0e0',
          }}
        >
          <Typography variant="caption" color="text.secondary">
            💡 Tip: Click on any message to expand and edit its content. Use "Save All Changes" to apply your modifications.
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
};

export default RediarizationPrompt;


// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Paper,
//   Typography,
//   TextField,
//   Button,
//   Stack,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Chip,
//   Divider,
//   Container,
//   IconButton,
//   Fade,
//   Slide,
// } from '@mui/material';
// import {
//   ExpandMore as ExpandMoreIcon,
//   Edit as EditIcon,
//   Save as SaveIcon,
//   Cancel as CancelIcon,
//   Restore as RestoreIcon,
//   CheckCircle as CheckCircleIcon,
//   Description as DescriptionIcon,
// } from '@mui/icons-material';

// const RediarizationPrompt = () => {
//   const [messages, setMessages] = useState({
//     m1: "You are an AI assistant tasked with analyzing customer service call recordings.\n    Upon receiving diarized call transcription segments, perform the following steps:",
//     m2: "Analyze the complete conversation by carefully reading through all speaker segments to understand context, flow, and key discussion points.",
//     m3: "Product Names, Service Types, Account Numbers, Issue Categories, Resolution Status, Customer Sentiments, Agent Actions",
//     m4: "Extract specific entities from each speaker segment. Focus on explicit mentions and clear contextual indicators. Maintain accuracy over completeness.",
//     m5: "Format each extracted entity with: entity type, value, speaker type, confidence level, and contextual relevance.",
//     m6: "Return a valid JSON object with arrays for each entity category. Include metadata for tracking and validation purposes.",
//     m7: "Ensure all JSON is properly formatted. Include only entities with high confidence. Maintain consistent naming conventions.",
//   });

//   const [originalMessages] = useState({
//     m1: "You are an AI assistant tasked with analyzing customer service call recordings.\n    Upon receiving diarized call transcription segments, perform the following steps:",
//     m2: "Analyze the complete conversation by carefully reading through all speaker segments to understand context, flow, and key discussion points.",
//     m3: "Product Names, Service Types, Account Numbers, Issue Categories, Resolution Status, Customer Sentiments, Agent Actions",
//     m4: "Extract specific entities from each speaker segment. Focus on explicit mentions and clear contextual indicators. Maintain accuracy over completeness.",
//     m5: "Format each extracted entity with: entity type, value, speaker type, confidence level, and contextual relevance.",
//     m6: "Return a valid JSON object with arrays for each entity category. Include metadata for tracking and validation purposes.",
//     m7: "Ensure all JSON is properly formatted. Include only entities with high confidence. Maintain consistent naming conventions.",
//   });

//   const [editingMessage, setEditingMessage] = useState(null);
//   const [tempValue, setTempValue] = useState('');
//   const [expanded, setExpanded] = useState('m1');
//   const [saveSuccess, setSaveSuccess] = useState(false);

//   const messageTitles = {
//     m1: "System Role Definition",
//     m2: "Transcript Understanding",
//     m3: "Entity Categories",
//     m4: "Extraction Logic",
//     m5: "Output Format",
//     m6: "JSON Format Specification",
//     m7: "Output Constraints"
//   };

//   const messageDescriptions = {
//     m1: "Define the AI assistant's primary role and responsibilities",
//     m2: "Instructions for understanding conversation context",
//     m3: "List of entity types to extract from transcripts",
//     m4: "Logic and rules for entity extraction process",
//     m5: "Structure for formatting extracted entities",
//     m6: "JSON schema and formatting requirements",
//     m7: "Constraints and validation rules for output"
//   };

//   const handleAccordionChange = (panel) => (event, isExpanded) => {
//     setExpanded(isExpanded ? panel : false);
//   };

//   const handleEdit = (messageKey) => {
//     setEditingMessage(messageKey);
//     setTempValue(messages[messageKey]);
//   };

//   const handleSave = (messageKey) => {
//     setMessages({ ...messages, [messageKey]: tempValue });
//     setEditingMessage(null);
//     setTempValue('');
//     showSaveSuccess();
//   };

//   const handleCancel = () => {
//     setEditingMessage(null);
//     setTempValue('');
//   };

//   const handleReset = (messageKey) => {
//     setMessages({ ...messages, [messageKey]: originalMessages[messageKey] });
//     setEditingMessage(null);
//     setTempValue('');
//   };

//   const handleResetAll = () => {
//     setMessages(originalMessages);
//     setEditingMessage(null);
//     setTempValue('');
//   };

//   const handleSaveAll = () => {
//     showSaveSuccess();
//     // Add your API call here
//     console.log('Saving all changes:', messages);
//   };

//   const showSaveSuccess = () => {
//     setSaveSuccess(true);
//     setTimeout(() => setSaveSuccess(false), 3000);
//   };

//   const getMessageNumber = (key) => key.replace('m', '');

//   const isModified = (key) => messages[key] !== originalMessages[key];

//   const hasAnyModifications = () => {
//     return Object.keys(messages).some(key => isModified(key));
//   };

//   return (
//     <Box
//       sx={{
//         // background: 'linear-gradient(135deg, #f5f7fa 0%, #e8eaf6 100%)',
//         // minHeight: '100vh',
//         p: 1,
//       }}
//     >
//       <Box >
//         {/* Header Section with Gradient */}
//         <Paper
//           elevation={0}
//           sx={{
//             p: 4,
//             // mb: 4,
//             // background: 'linear-gradient(135deg, #7626dc 0%, #5e35b1 100%)',
//             borderRadius: 4,
//             // boxShadow: '0 8px 32px rgba(118, 38, 220, 0.3)',
//             position: 'relative',
//             overflow: 'hidden',
//             '&::before': {
//               content: '""',
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
//               pointerEvents: 'none',
//             }
//           }}
//         >
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}>
//             <Box>
//               <Typography variant="h4" fontWeight="bold" sx={{ mb: 1, color: 'black', letterSpacing: '-0.5px' }}>
//                 ✨ Prompt Configuration
//               </Typography>
//               <Typography variant="body1" sx={{ color: 'black' }}>
//                 Configure and customize AI prompt messages for rediarization analysis
//               </Typography>
//             </Box>
//             <Stack direction="row" spacing={2}>
//               <Button
//                 startIcon={<RestoreIcon />}
//                 onClick={handleResetAll}
//                 disabled={!hasAnyModifications()}
//                 variant="outlined"
//                 sx={{
//                     textTransform: 'none',
//                   backgroundColor: 'white',
//                   color: '#7626dc',
//                   fontWeight: 600,
//                   px: 3,
//                   boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//                   '&:hover': {
//                     backgroundColor: '#f5f5f5',
//                     transform: 'translateY(-2px)',
//                     boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
//                   },
//                   transition: 'all 0.3s ease',
//                   // '&:disabled': {
//                   //   borderColor: 'rgba(255,255,255,0.2)',
//                   //   color: 'rgba(255,255,255,0.4)',
//                   // }
//                 }}
//               >
//                 Reset All
//               </Button>
//               <Button
//                 startIcon={saveSuccess ? <CheckCircleIcon /> : <SaveIcon />}
//                 variant="contained"
//                 onClick={handleSaveAll}
//                 sx={{
//                   textTransform: 'none',
//                   backgroundColor: 'white',
//                   color: '#7626dc',
//                   fontWeight: 600,
//                   px: 3,
//                   boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//                   '&:hover': {
//                     backgroundColor: '#f5f5f5',
//                     transform: 'translateY(-2px)',
//                     boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
//                   },
//                   transition: 'all 0.3s ease',
//                 }}
//               >
//                 {saveSuccess ? 'Changes Saved!' : 'Save All Changes'}
//               </Button>
//             </Stack>
//           </Box>
//         </Paper>

//         {/* Success Message */}
//         <Fade in={saveSuccess}>
//           <Paper
//             elevation={0}
//             sx={{
//               p: 2,
//               // mb: 3,
//               backgroundColor: '#4caf50',
//               color: 'white',
//               borderRadius: 2,
//               display: 'flex',
//               alignItems: 'center',
//               gap: 2,
//             }}
//           >
//             <CheckCircleIcon />
//             <Typography fontWeight={600}>Successfully saved all changes!</Typography>
//           </Paper>
//         </Fade>

//         {/* Messages Section */}
//         <Stack spacing={1}>
//           {Object.entries(messages).map(([key, value], index) => (
//             <Slide key={key} direction="up" in={true} timeout={300 + index * 100}>
//               <Accordion
//                 expanded={expanded === key}
//                 onChange={handleAccordionChange(key)}
//                 sx={{
//                   backgroundColor: 'white',
//                   '&:before': { display: 'none' },
//                   boxShadow: isModified(key)
//                     ? '0 4px 20px rgba(255, 152, 0, 0.2)'
//                     : '0 2px 12px rgba(0,0,0,0.08)',
//                   borderRadius: '16px !important',
//                   border: isModified(key) ? '2px solid #ff9800' : '2px solid transparent',
//                   transition: 'all 0.3s ease',
//                   '&:hover': {
//                     boxShadow: '0 6px 24px rgba(118, 38, 220, 0.15)',
//                     transform: 'translateY(-2px)',
//                   },
//                   overflow: 'hidden',
//                   position: 'relative',
//                   '&::before': isModified(key) ? {
//                     content: '""',
//                     position: 'absolute',
//                     left: 0,
//                     top: 0,
//                     bottom: 0,
//                     width: '4px',
//                     background: 'linear-gradient(180deg, #ff9800 0%, #f57c00 100%)',
//                   } : {},
//                 }}
//               >
//                 <AccordionSummary
//                   expandIcon={<ExpandMoreIcon sx={{ color: '#7626dc' }} />}
//                   sx={{
//                     '&:hover': {
//                       backgroundColor: '#fafafa',
//                     },
//                     borderRadius: '16px',
//                     px: 3,
//                     py: 1.5,
//                   }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%', pr: 2 }}>
//                     <Chip
//                       label={`M${getMessageNumber(key)}`}
//                       size="medium"
//                       sx={{
//                         background: 'linear-gradient(135deg, #7626dc 0%, #5e35b1 100%)',
//                         color: 'white',
//                         fontWeight: 'bold',
//                         minWidth: 50,
//                         height: 36,
//                         fontSize: '0.9rem',
//                         boxShadow: '0 2px 8px rgba(118, 38, 220, 0.3)',
//                       }}
//                     />
//                     <Box sx={{ flexGrow: 1 }}>
//                       <Typography fontWeight={700} sx={{ fontSize: '1.1rem', color: '#1a1a1a', mb: 0.5 }}>
//                         {messageTitles[key]}
//                       </Typography>
//                       <Typography variant="caption" sx={{ color: '#666', fontSize: '0.85rem' }}>
//                         {messageDescriptions[key]}
//                       </Typography>
//                     </Box>
//                     {isModified(key) && (
//                       <Chip
//                         label="Modified"
//                         size="small"
//                         icon={<DescriptionIcon sx={{ fontSize: 16 }} />}
//                         sx={{
//                           backgroundColor: '#fff3e0',
//                           color: '#f57c00',
//                           fontWeight: 600,
//                           fontSize: '0.75rem',
//                           border: '1px solid #ffb74d',
//                         }}
//                       />
//                     )}
//                   </Box>
//                 </AccordionSummary>
//                 <AccordionDetails sx={{ px: 3, pb: 3 }}>
//                   <Divider sx={{ mb: 3, borderColor: '#e0e0e0' }} />
//                   {editingMessage === key ? (
//                     <Box>
//                       <TextField
//                         fullWidth
//                         multiline
//                         minRows={6}
//                         maxRows={16}
//                         value={tempValue}
//                         onChange={(e) => setTempValue(e.target.value)}
//                         variant="outlined"
//                         sx={{
//                           mb: 2,
//                           '& .MuiOutlinedInput-root': {
//                             fontFamily: '"Fira Code", "Courier New", monospace',
//                             fontSize: '0.9rem',
//                             backgroundColor: '#f8f9fa',
//                             borderRadius: 2,
//                             '& fieldset': {
//                               borderColor: '#7626dc',
//                               borderWidth: 2,
//                             },
//                             '&:hover fieldset': {
//                               borderColor: '#5e35b1',
//                             },
//                             '&.Mui-focused fieldset': {
//                               borderColor: '#7626dc',
//                             },
//                           },
//                         }}
//                       />
//                       <Stack direction="row" spacing={2}>
//                         <Button
//                           startIcon={<SaveIcon />}
//                           variant="contained"
//                           onClick={() => handleSave(key)}
//                           sx={{
//                             textTransform: 'none',
//                             background: 'linear-gradient(135deg, #7626dc 0%, #5e35b1 100%)',
//                             fontWeight: 600,
//                             px: 3,
//                             '&:hover': {
//                               background: 'linear-gradient(135deg, #5e35b1 0%, #4527a0 100%)',
//                             },
//                           }}
//                         >
//                           Save Changes
//                         </Button>
//                         <Button
//                           startIcon={<CancelIcon />}
//                           variant="outlined"
//                           onClick={handleCancel}
//                           sx={{
//                             textTransform: 'none',
//                             borderColor: '#bdbdbd',
//                             color: '#666',
//                             fontWeight: 600,
//                             '&:hover': {
//                               borderColor: '#757575',
//                               backgroundColor: '#f5f5f5',
//                             },
//                           }}
//                         >
//                           Cancel
//                         </Button>
//                         {isModified(key) && (
//                           <Button
//                             startIcon={<RestoreIcon />}
//                             variant="outlined"
//                             onClick={() => handleReset(key)}
//                             sx={{
//                               textTransform: 'none',
//                               borderColor: '#ff9800',
//                               color: '#f57c00',
//                               fontWeight: 600,
//                               '&:hover': {
//                                 borderColor: '#f57c00',
//                                 backgroundColor: '#fff3e0',
//                               },
//                             }}
//                           >
//                             Reset to Default
//                           </Button>
//                         )}
//                       </Stack>
//                     </Box>
//                   ) : (
//                     <Box>
//                       <Paper
//                         variant="outlined"
//                         sx={{
//                           p: 3,
//                           mb: 2,
//                           background: 'linear-gradient(135deg, #f8f9fa 0%, #f1f3f5 100%)',
//                           fontFamily: '"Fira Code", "Courier New", monospace',
//                           fontSize: '0.9rem',
//                           whiteSpace: 'pre-wrap',
//                           wordBreak: 'break-word',
//                           maxHeight: 400,
//                           overflow: 'auto',
//                           borderRadius: 2,
//                           borderColor: '#e0e0e0',
//                           borderWidth: 2,
//                           color: '#2d3436',
//                           lineHeight: 1.7,
//                           '&::-webkit-scrollbar': {
//                             width: '8px',
//                           },
//                           '&::-webkit-scrollbar-track': {
//                             background: '#f1f1f1',
//                             borderRadius: '4px',
//                           },
//                           '&::-webkit-scrollbar-thumb': {
//                             background: '#7626dc',
//                             borderRadius: '4px',
//                             '&:hover': {
//                               background: '#5e35b1',
//                             },
//                           },
//                         }}
//                       >
//                         {value}
//                       </Paper>
//                       <Stack direction="row" spacing={2}>
//                         <Button
//                           startIcon={<EditIcon />}
//                           variant="contained"
//                           onClick={() => handleEdit(key)}
//                           sx={{
//                             textTransform: 'none',
//                             background: 'linear-gradient(135deg, #7626dc 0%, #5e35b1 100%)',
//                             fontWeight: 600,
//                             px: 3,
//                             '&:hover': {
//                               background: 'linear-gradient(135deg, #5e35b1 0%, #4527a0 100%)',
//                               transform: 'translateY(-2px)',
//                               boxShadow: '0 4px 12px rgba(118, 38, 220, 0.4)',
//                             },
//                             transition: 'all 0.3s ease',
//                           }}
//                         >
//                           Edit Message
//                         </Button>
//                         {isModified(key) && (
//                           <Button
//                             startIcon={<RestoreIcon />}
//                             variant="outlined"
//                             onClick={() => handleReset(key)}
//                             sx={{
//                               textTransform: 'none',
//                               borderColor: '#ff9800',
//                               color: '#f57c00',
//                               fontWeight: 600,
//                               '&:hover': {
//                                 borderColor: '#f57c00',
//                                 backgroundColor: '#fff3e0',
//                               },
//                             }}
//                           >
//                             Reset to Default
//                           </Button>
//                         )}
//                       </Stack>
//                     </Box>
//                   )}
//                 </AccordionDetails>
//               </Accordion>
//             </Slide>
//           ))}
//         </Stack>

//         {/* Info Section */}
//         <Paper
//           elevation={0}
//           sx={{
//             p: 3,
//             mt: 4,
//             background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
//             borderRadius: 3,
//             border: '2px solid #90caf9',
//           }}
//         >
//           <Typography variant="body1" sx={{ color: '#1565c0', fontWeight: 500, display: 'flex', alignItems: 'center', gap: 1 }}>
//             💡 <strong>Pro Tip:</strong> Click on any message accordion to expand and edit its content. Modified messages are highlighted in orange. Use "Save All Changes" to apply your modifications across all prompts.
//           </Typography>
//         </Paper>
//       </Box>
//     </Box>
//   );
// };

// export default RediarizationPrompt;